import * as React from 'react'
import TextField from 'material-ui/TextField'
import {url} from '../../App/PublicRoute'
import {LoginForm} from './LoginFormState'
import {LoginFormAction} from './LoginFormActions'
import injectSheet from 'react-jss'
import {WithClasses} from '../../View/Helper'

const styles = {
    passwordLostText: {
        fontSize: '14px',
        textAlign: 'right'
    },
    networkErrorText: {
        color: 'red',
        float: 'left',
        fontSize: '14px'
    }
}

interface Properties {
    autofocus: LoginFormAutofocus,
    state: LoginForm,
    dispatch: (action: LoginFormAction) => void
}

export const LoginInputs =
    injectSheet<Properties>(styles)(
        ({classes, autofocus, state, dispatch}: WithClasses<Properties>) => {
            const {input, validation} = state
            return (
                <div>
                    <TextField
                        errorStyle={{position: 'absolute', bottom: '-15px'}}
                        floatingLabelText="E-Mail"
                        fullWidth={true}
                        errorText={
                            validation.email === 'Mandatory' ?
                                'E-Mail ist ein Pflichtfeld' :
                                validation.email === 'InvalidEmail' ?
                                    'Ungültige E-Mail-Adresse' :
                                    state.error === 'EmailNotFound' ?
                                        'E-Mail-Adresse existiert nicht' :
                                        null}
                        value={input.email}
                        onChange={(event, email: string) => dispatch({
                            type: 'EmailChanged',
                            email
                        })}
                        autoFocus={autofocus === 'Email'}
                    />
                    <TextField
                        errorStyle={{position: 'absolute', bottom: '-15px'}}
                        floatingLabelText="Password"
                        type="password"
                        fullWidth={true}
                        errorText={
                            validation.password === 'Mandatory' ?
                                'Passwort ist ein Pflichtfeld' :
                                state.error === 'PasswordWrong' ?
                                    'Passwort falsch' :
                                    null}
                        value={input.password}
                        onChange={(event, password: string) => dispatch({
                            type: 'PasswordChanged',
                            password
                        })}
                        autoFocus={autofocus === 'Password'}
                    />
                    {state.error === 'GeneralError' &&
                    <span className={classes.networkErrorText}>
                                Netzwerkfehler
                            </span>}
                    <p className={classes.passwordLostText}>
                        <a
                            className="text-muted"
                            href={url({type: 'PasswordLost'})}
                        >
                            Password lost?
                        </a>
                    </p>
                </div>
            )
        }
    )

export type LoginFormAutofocus = 'Email' | 'Password'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/LoginForm/LoginFormView.tsx